import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Fab,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  IconButton,
  FormControl,
  InputLabel,
  Input,
  InputAdornment
} from '@material-ui/core';
import {
  Add,
  Edit,
  Delete,
  VisibilityOff,
  Visibility
} from '@material-ui/icons';
import PerfectScrollbar from 'react-perfect-scrollbar';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Bureau extends React.Component {
  constructor() {
    super();
    this.state = {
      bureau: [],
      fax: "",
      numero: "",
      adresse: "",
      code_postal: "",
      ville: "",
      telephone: "",
      email: "",
      heure_debut: "",
      heure_pause: "",
      heure_reprise: "",
      heure_fin: "",
      iframe: "",
      compte_email: "",
      mdp_email: "",
      isLogged: true,
      redirect: false,
      newModalOpen: false,
      deleteModalOpen: false,
      deleteId: "",
      modifedId: "",
      snackbarMessage: "",
      snackbarOpen: false,
      sidebarOpen: false,
      putModalOpen: false,
      putModalOpen2: false,
      redirectLogOut: false,
      limit: false
    }
  }

  handleChangeInput = (event) => {
    switch (event.target.name) {
      case 'fax':
        this.setState({ fax: event.target.value })
        break;
      case 'numero':
        this.setState({ numero: event.target.value })
        break;
      case 'adresse':
        this.setState({ adresse: event.target.value })
        break;
      case 'code_postal':
        this.setState({ code_postal: event.target.value })
        break;
      case 'ville':
        this.setState({ ville: event.target.value })
        break;
      case 'email':
        this.setState({ email: event.target.value })
        break;
      case 'heure_debut':
        this.setState({ heure_debut: event.target.value })
        break;
      case 'heure_pause':
        this.setState({ heure_pause: event.target.value })
        break;
      case 'heure_reprise':
        this.setState({ heure_reprise: event.target.value })
        break;
      case 'heure_fin':
        this.setState({ heure_fin: event.target.value })
        break;
      case 'iframe':
        this.setState({ iframe: event.target.value })
        break;
      case 'compte_email':
        this.setState({ compte_email: event.target.value })
        break;
      case 'mdp_email':
        this.setState({ mdp_email: event.target.value })
        break;
      default:
        break;
    }
  }

  deleteBureau = () => {
    this.handleCloseDeleteModal();
    const bureau_id = this.state.bureau[this.state.deleteId].id
    fetch(SERVER_ADDRESS + '/bureaux/' + bureau_id,
      {
        method: 'DELETE',
        headers: new Headers({
          'authorization': 'Bearer ' + localStorage.getItem('token')
        })
      }
    )
      .then(() => { this.getData() })
      .then(
        (res) => {
          this.setState({
            snackbarOpen: true,
            snackbarMessage: "Utilisateur supprimé"
          })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  addBureau = () => {
    this.handleCloseNewModal();
    let bureau = {
      fax: this.state.fax,
      numero: this.state.numero,
      adresse: this.state.adresse,
      code_postal: this.state.code_postal,
      ville: this.state.ville,
      telephone: this.state.telephone,
      email: this.state.email,
      heure_debut: this.state.heure_debut,
      heure_pause: this.state.heure_pause,
      heure_reprise: this.state.heure_reprise,
      heure_fin: this.state.heure_fin,
      iframe: this.state.iframe,
      compte_email: this.state.compte_email,
      mdp_email: this.state.mdp_email
    }
    fetch(SERVER_ADDRESS + '/bureaux',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(bureau),
      })
      .then(res => {
        res.json()
        console.log(res)
      })
      .then(() => { this.getData() })
      .then(res => this.setState({ snackbarMessage: "Bureau ajouté." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  putBureau = () => {
    this.handleClosePutModal();
    this.handleClosePutModal2();
    let bureau = {
      fax: this.state.fax,
      numero: this.state.numero,
      adresse: this.state.adresse,
      code_postal: this.state.code_postal,
      ville: this.state.ville,
      telephone: this.state.telephone,
      email: this.state.email,
      heure_debut: this.state.heure_debut,
      heure_pause: this.state.heure_pause,
      heure_reprise: this.state.heure_reprise,
      heure_fin: this.state.heure_fin,
      iframe: this.state.iframe,
      compte_email: this.state.compte_email,
      mdp_email: this.state.mdp_email
    }
    let bureau_id = this.state.bureau[this.state.modifedId].id
    console.log(bureau_id)
    fetch(SERVER_ADDRESS + '/bureaux/' + bureau_id,
      {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(bureau),
      })
      .then(
        () => {
          fetch(SERVER_ADDRESS + '/bureaux',
            {
              headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('token')
              }),

            }
          )
            .then(res => res.json())
            .then(res => this.setState({ bureau: res }))
            .then(
              () => console.log(this.state.bureau)
            )
        }
      )
      .then(res => this.setState({ snackbarMessage: "Bureau modifié." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
      .then(
        () => {
          const newArrayBureau = this.state.bureau
          newArrayBureau[this.state.modifedId] = {
            id: bureau_id,
            email: this.state.email
          }
          this.setState({ bureau: newArrayBureau })
        }
      )
  }

  handleClosePutModal = () => {
    this.setState({ putModalOpen: false })
  }

  handleClosePutModal2 = () => {
    this.setState({ putModalOpen2: false })
  }

  handleOpenPutModal = (index) => {
    let user_id = this.state.bureau[index].id
    fetch(SERVER_ADDRESS + '/bureaux/' + user_id)
      .then(res => res.json())
      .then(res => {
        this.setState({
          fax: res[0].fax,
          numero: res[0].numero,
          adresse: res[0].adresse,
          code_postal: res[0].code_postal,
          ville: res[0].ville,
          telephone: res[0].telephone,
          email: res[0].email,
          heure_debut: res[0].heure_debut,
          heure_pause: res[0].heure_pause,
          heure_reprise: res[0].heure_reprise,
          heure_fin: res[0].heure_fin,
          iframe: res[0].iframe,
          compte_email: res[0].compte_email,
          mdp_email: res[0].mdp_email
        }, () => {
          this.setState({ putModalOpen: true })
          this.setState({ modifedId: index })
        })
      })
  }

  handleOpenPutModal2 = (index) => {
    let user_id = this.state.bureau[index].id
    fetch(SERVER_ADDRESS + '/bureaux/' + user_id)
      .then(res => res.json())
      .then(res => {
        this.setState({
          fax: res[0].fax,
          numero: res[0].numero,
          adresse: res[0].adresse,
          code_postal: res[0].code_postal,
          ville: res[0].ville,
          telephone: res[0].telephone,
          email: res[0].email,
          heure_debut: res[0].heure_debut,
          heure_pause: res[0].heure_pause,
          heure_reprise: res[0].heure_reprise,
          heure_fin: res[0].heure_fin,
          iframe: res[0].iframe,
          compte_email: res[0].compte_email,
          mdp_email: res[0].mdp_email
        }, () => {
          this.setState({ putModalOpen2: true })
          this.setState({ modifedId: index })
        })
      })
  }

  handleCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false })
  }

  handleOpenDeleteModal = (index) => {
    this.setState({ deleteModalOpen: true })
    this.setState({ deleteId: index })
  }

  handleOpenNewModal = () => {
    this.setState({
      fax: "",
      numero: "",
      adresse: "",
      code_postal: "",
      ville: "",
      telephone: "",
      email: "",
      heure_debut: "",
      heure_pause: "",
      heure_reprise: "",
      heure_fin: "",
      iframe: "",
      compte_email: "",
      mdp_email: ""
    }, () => {
      this.setState({ newModalOpen: true })
    })
  }

  handleCloseNewModal = () => {
    this.setState({ newModalOpen: false })
  }

  openMenu = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen })
    const menu = document.querySelector('.side-nav')
    if (this.state.sidebarOpen === false) {
      menu.style.display = "block"
    }
    else {
      menu.style.display = "none"
    }
  }

  getData = () => {
    fetch(SERVER_ADDRESS + '/bureaux',
      {
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),

      }
    )
      .then(res => res.json())
      .then((res) => {
        this.setState({ bureau: res })
      })

  }

  componentDidMount() {
    const token = {
      token: localStorage.getItem('token')
    }

    fetch(SERVER_ADDRESS + '/token',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(token),
      })
      .then(res => res.json())
      .then(
        (res) => {
          this.setState(
            {
              isLogged: res.succes,
              redirect: res.succes ? false : true
            });
        }
      )
    this.getData()
  }

  logOut = () => {
    this.setState({ redirectLogOut: true })
    localStorage.setItem('token', "")
  }

  showPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  render() {
    return (
      <>
        <Grid className="item" item>
          <Paper elevation={1}>
            <Card>
              <CardHeader
                className="jtestd"
                title="Compte messagerie"
              />
              <Divider />
              <CardContent className="content">
                <PerfectScrollbar>
                  <div className="inner">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell >#</TableCell>
                          <TableCell>Ville</TableCell>
                          <TableCell>Compte de messagerie</TableCell>
                          <TableCell>Editer</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.bureau.map((bureaux, index) => (
                          <TableRow
                            hover
                            key={bureaux.id}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{bureaux.ville}</TableCell>
                            <TableCell>{bureaux.compte_email}</TableCell>
                            <TableCell>

                              <Button
                                style={{ backgroundColor: "#1976d2", color: 'white' }}
                                onClick={() => this.handleOpenPutModal2(index)}
                                size="small"
                                startIcon={<Edit />}
                              >
                                Editer
                          </Button>

                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </PerfectScrollbar>
              </CardContent>
            </Card>
          </Paper>
        </Grid>

        <Dialog open={this.state.putModalOpen2} onClose={this.handleClosePutModal2} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Modifier un compte messagerie</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour modifer ce compte de messagerie veuillez saisir les champs obligatoire.
                </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="compte_email"
              label="compte_email"
              type="email"
              fullWidth
              name="compte_email"
              onChange={this.handleChangeInput}
              defaultValue={this.state.compte_email}
            />
            <FormControl fullWidth>
              <InputLabel>Mot de passe</InputLabel>
              <Input
                id="standard-password-input"
                fullWidth
                type={this.state.showPassword ? 'text' : 'password'}
                onChange={this.handleChangeInput}
                name="mdp_email"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={this.showPassword}
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePutModal2} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.putBureau} color="primary">
              Modifier
                  </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
        />






        <Grid className="item" item>
          <Paper elevation={1}>
            <Card>
              <CardHeader
                className="jtestd"
                action={
                  <Fab
                    style={{ backgroundColor: "#1976d2", color: 'white' }}
                    onClick={this.handleOpenNewModal}
                    size="small"
                  >
                    <Add />
                  </Fab>
                }
                title="Bureau"
              />
              <Divider />
              <CardContent className="content">
                <PerfectScrollbar>
                  <div className="inner">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Ville</TableCell>
                          <TableCell>Horraire</TableCell>
                          <TableCell>Téléphone</TableCell>
                          <TableCell>Fax</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>Adresse</TableCell>
                          <TableCell>Iframe</TableCell>
                          <TableCell>Editer / Supprimer</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.bureau.map((bureaux, index) => (
                          <TableRow
                            hover
                            key={bureaux.id}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{bureaux.ville}</TableCell>
                            <TableCell>
                              <div className="adminh">
                                <p>{bureaux.heure_debut} <span>-</span> {bureaux.heure_pause}</p>
                                <p>{bureaux.heure_reprise} <span>-</span> {bureaux.heure_fin}</p>
                              </div>
                            </TableCell>
                            <TableCell>{bureaux.telephone}</TableCell>
                            <TableCell>{bureaux.fax}</TableCell>
                            <TableCell>{bureaux.email}</TableCell>
                            <TableCell>{bureaux.numero} {bureaux.adresse}, {bureaux.code_postal} {bureaux.ville}</TableCell>
                            <TableCell><a href={bureaux.iframe}>Lien de l'iframe</a></TableCell>
                            <TableCell>

                              <Button
                                style={{ backgroundColor: "#1976d2", color: 'white' }}
                                onClick={() => this.handleOpenPutModal(index)}
                                size="small"
                                startIcon={<Edit />}
                              >
                                Editer
                          </Button>

                              <Button
                                style={{ marginLeft: '10px' }}
                                disabled={this.state.limit}
                                variant="contained"
                                onClick={() => this.handleOpenDeleteModal(index)}
                                color="secondary"
                                size="small"
                                endIcon={<Delete />}
                              >
                                Supprimer
                          </Button>

                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </PerfectScrollbar>
              </CardContent>
            </Card>
          </Paper>
        </Grid>

        <Dialog open={this.state.newModalOpen} onClose={this.handleCloseNewModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Crée un nouveau bureau</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour crée un bureau veuillez remplir les champs obligatoire.
                  </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="fax"
              label="Fax"
              type="email"
              fullWidth
              name="fax"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="numero"
              label="Numéro"
              type="email"
              fullWidth
              name="numero"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="adresse"
              label="Adresse"
              type="email"
              fullWidth
              name="adresse"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="code_postal"
              label="Code postal"
              type="email"
              fullWidth
              name="code_postal"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="ville"
              label="Ville"
              type="email"
              fullWidth
              name="ville"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="telephone"
              label="Téléphone"
              type="email"
              fullWidth
              name="telephone"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="email"
              label="Email"
              type="email"
              fullWidth
              name="email"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="heure_debut"
              label="Heure début"
              type="email"
              fullWidth
              name="heure_debut"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="heure_pause"
              label="Heure pause"
              type="email"
              fullWidth
              name="heure_pause"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="heure_reprise"
              label="Heure reprise"
              type="email"
              fullWidth
              name="heure_reprise"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="heure_fin"
              label="Heure fin"
              type="email"
              fullWidth
              name="heure_fin"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="iframe"
              label="Iframe"
              type="iframe"
              fullWidth
              name="iframe"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="compte_email"
              label="Compte email"
              type="email"
              fullWidth
              name="compte_email"
              onChange={this.handleChangeInput}
            />
            <FormControl fullWidth>
              <InputLabel>Mot de passe de l'email</InputLabel>
              <Input
                id="standard-password-input"
                fullWidth
                type={this.state.showPassword ? 'text' : 'password'}
                onChange={this.handleChangeInput}
                name="mdp_email"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={this.showPassword}
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseNewModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.addBureau} color="primary">
              Créer
                  </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.deleteModalOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Suppression d'un bureau"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Etes vous sur de vouloir supprimer le bureau ?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDeleteModal} color="primary">
              Non
              </Button>
            <Button onClick={this.deleteBureau} color="primary" autoFocus>
              Oui
              </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.putModalOpen} onClose={this.handleClosePutModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Modifier un bureau</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour modifer ce bureau veuillez saisir les champs obligatoire.
                </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="fax"
              label="Fax"
              type="email"
              fullWidth
              name="fax"
              onChange={this.handleChangeInput}
              defaultValue={this.state.fax}
            />
            <TextField
              margin="dense"
              id="numero"
              label="Numéro"
              type="email"
              fullWidth
              name="numero"
              onChange={this.handleChangeInput}
              defaultValue={this.state.numero}
            />
            <TextField
              margin="dense"
              id="adresse"
              label="Adresse"
              type="email"
              fullWidth
              name="adresse"
              onChange={this.handleChangeInput}
              defaultValue={this.state.adresse}
            />
            <TextField
              margin="dense"
              id="code_postal"
              label="Code postal"
              type="email"
              fullWidth
              name="code_postal"
              onChange={this.handleChangeInput}
              defaultValue={this.state.code_postal}
            />
            <TextField
              margin="dense"
              id="ville"
              label="Ville"
              type="email"
              fullWidth
              name="ville"
              onChange={this.handleChangeInput}
              defaultValue={this.state.ville}
            />
            <TextField
              margin="dense"
              id="telephone"
              label="Téléphone"
              type="email"
              fullWidth
              name="telephone"
              onChange={this.handleChangeInput}
              defaultValue={this.state.telephone}
            />
            <TextField
              margin="dense"
              id="email"
              label="Email"
              type="email"
              fullWidth
              name="email"
              onChange={this.handleChangeInput}
              defaultValue={this.state.email}
            />
            <TextField
              margin="dense"
              id="heure_debut"
              label="Heure début"
              type="email"
              fullWidth
              name="heure_debut"
              onChange={this.handleChangeInput}
              defaultValue={this.state.heure_debut}
            />
            <TextField
              margin="dense"
              id="heure_pause"
              label="Heure pause"
              type="email"
              fullWidth
              name="heure_pause"
              onChange={this.handleChangeInput}
              defaultValue={this.state.heure_pause}
            />
            <TextField
              margin="dense"
              id="heure_reprise"
              label="Heure reprise"
              type="email"
              fullWidth
              name="heure_reprise"
              onChange={this.handleChangeInput}
              defaultValue={this.state.heure_reprise}
            />
            <TextField
              margin="dense"
              id="heure_fin"
              label="Heure fin"
              type="email"
              fullWidth
              name="heure_fin"
              onChange={this.handleChangeInput}
              defaultValue={this.state.heure_fin}
            />
            <TextField
              margin="dense"
              id="iframe"
              label="Iframe"
              type="iframe"
              fullWidth
              name="iframe"
              onChange={this.handleChangeInput}
              defaultValue={this.state.iframe}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePutModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.putBureau} color="primary">
              Modifier
                  </Button>
          </DialogActions>
        </Dialog>


        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
        />

      </>
    );
  }
}

export default Bureau;
